import styled from 'styled-components/macro'

export const Flex = styled.div<{ justify?: string; align?: string; margin?: string; direct?: string }>`
  display: flex;
  justify-content: ${({ justify }) => justify || 'flex-start'};
  align-items: ${({ align }) => align || 'center'};
  margin: ${({ margin }) => margin || '0'};
  flex-direction: ${({ direct }) => direct || 'row'};
`

export const Container = styled.div`
  padding: 0 12px;
`

export const Header = styled.div`
  padding: 20px 0;
`

export const Divider = styled.div<{ margin?: string }>`
  background: #e5e5e5;
  height: 1px;
  width: 100%;
  padding: 0 18px;
  box-sizing: content-box;
  margin: ${({ margin }) => margin || '0 0 0 -18px'};
`

export const IconButton = styled.div<{ disabled?: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: ${({ disabled }) => (disabled ? '#C9C9C9' : 'linear-gradient(112deg, #14D89D 0%, #0AC4DD 100%)')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`
